"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./iso-locales-find"));
__export(require("./iso-locales-db"));
const lcid = require("./lcid");
exports.lcid = lcid;
const bcp47 = require("./bcp-47");
exports.bcp47 = bcp47;
const iso639 = require("./iso-639");
exports.iso639 = iso639;
const iso3166 = require("./iso-3166/iso-3166-impl");
exports.iso3166 = iso3166;
const iso15924 = require("./iso-15924");
exports.iso15924 = iso15924;
const m49 = require("./m49");
exports.m49 = m49;
//# sourceMappingURL=index-common.js.map